import array from './array'
import string from './string'

export default function () {
  array()
  string()
}
